import { UI, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from 'native-base';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import {
  getValidationCreateSchema,
  MaskTime,
  TimeSelectionFormData,
  validateTime,
} from './constants';

export interface TimeSelectionProps {
  selectedValue?: string;
  onValueChange: (value?: string) => void;
  forceMobile?: boolean;
}

export const TimeSelection: React.FC<TimeSelectionProps> = ({
  onValueChange,
  selectedValue,
  forceMobile,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const tableForm = useForm<TimeSelectionFormData>({
    mode: 'all',
    reValidateMode: 'onBlur',
    defaultValues: {
      time: selectedValue,
    },
    resolver: zodResolver(getValidationCreateSchema()),
  });

  const handleInputBlur = () => {
    const currentValue = tableForm.getValues('time');

    if (validateTime(currentValue)) {
      onValueChange(MaskTime(currentValue));
    } else {
      onValueChange('');
    }

    if (isFocused) {
      setIsFocused(false);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const error = tableForm.formState.errors?.time;

  useEffect(() => {
    if (tableForm.formState.errors?.time) {
      onValueChange('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableForm.formState.errors?.time]);

  return (
    <VStack flex={1}>
      <UI.Text pb="inline.nano" variant="semibold">
        Horário
      </UI.Text>
      <Box
        maxW={
          forceMobile ? 'full' : Utils.Responsive.PhoneTablet({ phone: 'full', tablet: '240px' })
        }
        w="full"
        flex={1}
        maxH="42px">
        <UI.Input
          flex={1}
          formControlFlex={1}
          control={tableForm.control}
          onBlur={handleInputBlur}
          onFocus={handleFocus}
          keyboardType="numeric"
          autoComplete="off"
          name="time"
          variant="filled"
          hasShadow={false}
          placeholder="Digite o horário (ex: 14:30)"
          mask={MaskTime}
        />
      </Box>
      {!!error && !isFocused && (
        <UI.Text fontSize="xs" color="feedback.error.default">
          {error.message}
        </UI.Text>
      )}
    </VStack>
  );
};
